var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll"},[(_vm.pollData)?_c('Poll',{attrs:{"type":"single","open":_vm.open,"gate":_vm.gate,"poll":_vm.pollData,"custom":_vm.custom}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }